import type { ServiceCategoryEntity } from "../../model";

import { SLASH } from "~/shared/str";

const BASE_URL = "categories";

const URLS = {
  create: BASE_URL,
  update: (serviceCategoryId: ServiceCategoryEntity.Schema["id"]) =>
    [BASE_URL, serviceCategoryId].join(SLASH),
  delete: (serviceCategoryId: ServiceCategoryEntity.Schema["id"]) =>
    [BASE_URL, serviceCategoryId].join(SLASH),
  get: (serviceCategoryId: ServiceCategoryEntity.Schema["id"]) =>
    [BASE_URL, serviceCategoryId].join(SLASH),
  getAll: BASE_URL,
  getPaginated: [BASE_URL, "getPage"].join(SLASH),
};

export { URLS };
